// extracted by mini-css-extract-plugin
export default {"custom-modal":"ModalManager_custom-modal__7Vl60","instructions-modal":"ModalManager_instructions-modal__jgnDs"};